import {HomepageHeaderArenaIconDefaultBox} from "./home-page-header-arena-icon.default.box";

export const HomepageHeaderArenaIconBox = HomepageHeaderArenaIconDefaultBox;
